






























import { Component, Vue } from "vue-property-decorator";

@Component
export default class InstanceGroupInstanceDeleteModal extends Vue {
    itemToBeDeleted: string = "";
    name: string = ""

    open(id: string, name: string) {
        this.itemToBeDeleted = id;
        this.name = name;
        this.$bvModal.show("modal-deleteInstanceGroupInstance");
    }

    decline() {
        this.$bvModal.hide("modal-deleteInstanceGroupInstance");
        this.itemToBeDeleted = "";
        this.name = "";
    }

    confirm() {
        this.$bvModal.hide("modal-deleteInstanceGroupInstance");
        this.$emit("delete", this.itemToBeDeleted);
        this.itemToBeDeleted = "";
        this.name = "";
    }
}
